import { isYes } from '../../../../../../../components/loan_application/utils/helpers';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { propertyTenantWillingToBeCommercialGuarantor } =
  loanFormModel.formField;

class IsPropertyTenantWillingToBeCommercialGuarantor implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    return isYes(
      application[propertyTenantWillingToBeCommercialGuarantor.name]
    );
  }
}

export default new IsPropertyTenantWillingToBeCommercialGuarantor();
